import { render, staticRenderFns } from "./medQuery.vue?vue&type=template&id=2205da8a&scoped=true"
import script from "./medQuery.vue?vue&type=script&lang=js"
export * from "./medQuery.vue?vue&type=script&lang=js"
import style0 from "./medQuery.vue?vue&type=style&index=0&id=2205da8a&prod&scoped=true&lang=css"
import style1 from "./medQuery.vue?vue&type=style&index=1&id=2205da8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205da8a",
  null
  
)

export default component.exports